import { SOCKET_MSG_TYPES } from './websocket.enums';

export interface DeSerializedMessage {
    messageType: number;
    message: any;
}

export interface BooksStreamMessage {
    stream: string;
    payload: BooksStreamPayload
}

export interface BooksStreamPayload {
    order_book_data: any[];
    trade_book_data: any[];
    rejections_data: any[];
    positions_data: any[];
}

export interface OIDataI {
    oi_change: number,
    oi_qty: number,
    oi_value: number,
    security_id: number,
    exchange: number
}

export interface FullQuoteSocketUpdate {
    CommandCategory: number;
    dpr: DPRSocketUpdateI;
    quote: QuoteSocketUpdateI;
    index?: QuoteSocketUpdateI;
    symbolId: number;
    LtpAndClosePrice: LTPClosePriceSocketUpdate;
    closePrice: number;
}

export interface QuoteSocketUpdateI {
    LowPrice: number;
    HighPrice: number;
    OpenPrice: number;
    ClosePrice: number;
    AvgTradePrice?: number;
    ExchangeId: string;
    LastTradePrice?: number;
    LastTradeQty?: number;
    LastTradeTime: number;
    LastUpdateTime?: number;
    SecurityId: number;
    TotalAskQty?: number;
    TotalBidQty?: number;
    Value?: number;
    Volume?: number;
    bitFields?: {
        tradeValueFlag: number;
        trend: number;
    }
    depth?: DepthSocketUpdateI[];
    response?: SOCKET_MSG_TYPES.QUOTE;
}

export interface DepthSocketUpdateI {
    AskPrice: number;
    AskQty: number;
    AvgAskPrice: number;
    AvgBidPrice: number;
    BidPrice: number;
    BidQty: number;
    NoOfAsks: number;
    NoOfBids: number;
}

export interface DepthOnlySocketUpdate {
    SecurityId: number;
    ExchangeId: number;
    depth: DepthSocketUpdateI[];
}

export interface DPRSocketUpdateI {
    ExchangeId: number;
    LowerPrice: number;
    SecurityId: number;
    UpperPrice: number;
    response: SOCKET_MSG_TYPES.DAILY_PRICE_RANGE;
}

export interface LTPClosePriceSocketUpdate {
    ClosePrice: number;
    ExchangeId: string;
    Ltp: number;
    SecurityId: number;
    response?: SOCKET_MSG_TYPES.LTP_Close_PRICE;
}

export interface GainerLoserSocketUpdate {
    GainerList: GainerLoserI[];
    LoserList: GainerLoserI[];
    response: SOCKET_MSG_TYPES.TOP_GAINERS_LOSERS
}

export interface GainerLoserI {
    changePercentage: number;
    closePrice: number;
    ltp: number;
    symbolId: number;
}

export interface subscribeQuoteParams {
    market_id: number;
    security_id: number;
    scrip_precision?: number;
    symbol_id?: number;
}

export interface SocketDepthObj {
    qty: number;
    price: number;
    no_of_order: number;
}

export interface SocketDepth {
    buy: Array<SocketDepthObj>;
    sell: Array<SocketDepthObj>;
    symbol_id: string;
    maxBidQty?: number;
    maxAskQty?: number;
}

export interface LTPAndClosePiceObj {
    LastTradePrice: number;
    SecurityId: number;
    ExchangeId: string;
    ClosePrice: number;
    PrevClose?: number;
    isLtp?: boolean;
}

export interface LTPClosePiceObj {
    last_trade_price: number;
    symbol_id?: number;
    market_id?: string;
    close_price: number;
    security_id?: number;
}

export interface SingleIndexQuotes {
    ExchangeId: string;
    SecurityId: number;
    HighPrice: number;
    LowPrice: number;
    OpenPrice: number;
    ClosePrice: number;
    Value: number;
    SymbolId?: number;
    symbol_id?: number;
    LastTradePrice?: number;
    LastTradeTime?: number;
}

export interface DPRDataI {
    lower_ckt_limit: number,
    upper_ckt_limit: number,
    security_id: number,
    market_id: string,
    symbol_id: number
}

export interface SocketMessageI {
    command: number;
    subscriptionType: number;
    exchangeId: number;
    securityId: number;
    msgType: number;
}

export interface LegSymbol {
    exchange: number;
    symbol: string;
    instrumentType: number;
    expiryType: number;
    expiryOffset: number;
    expiryDate: string;
    strikeSelection: number;
    strikeValue?: number;
    optionMode: number;
    underlyingType?: number;
    candleInterval?: number;
    itmDepth?: number;
    otmDepth?: number;
    minPriceRange?: number;
    maxPriceRange?: number;
    strikeOperator?: number;
    timestamp?: number;
    groupName?: string;
}

export interface DeltaSocketUpdate {
    delta: number;
    exchangeId: string;
    securityId: number;
    response?: SOCKET_MSG_TYPES.DELTA;
}